import moment from 'moment';
import { Button } from 'semantic-ui-react';
import { agGridDateFieldComparator } from '../../table/helpers';

export const SurveysColumnDefs = (set_showAnswers) => [
  {
    headerName: 'Fecha',
    field: 'updatedAt',
    cellRenderer: (params) => moment(params.data.updatedAt).format('DD-MM-YYYY'),
    comparator: agGridDateFieldComparator('updatedAt'),
  },
  {
    headerName: 'Cédula',
    field: 'identification',
    flex: 1.2,
    minWidth: 120,
  },
  {
    headerName: 'Nombre',
    field: 'name',
    flex: 1.5,
    minWidth: 150,
  },
  {
    headerName: 'Apellido',
    field: 'lastName',
    flex: 1.5,
    minWidth: 150,
  },
  {
    headerName: 'Celular',
    field: 'phone',
    flex: 1.2,
    minWidth: 120,
  },
  {
    headerName: 'Ver',
    field: 'id',
    cellRenderer: (params) => (
      <Button primary onClick={() => set_showAnswers(params.value)} size="small">
        Ver Respuestas
      </Button>
    ),
    sortable: false,
    filter: false,
    flex: 0.8,
    minWidth: 100,
  },
];
